import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '@/components/IconBase'

const directions = ({ isRtl } = {}) => ({
  left: isRtl ? 270 : 90,
  right: isRtl ? 90 : 270,
  up: 360,
  down: 180,
})

const ArrowBox = styled(IconBase)(
  ({ $direction, isVisible = true, theme: { isRtl } }) =>
    css({
      svg: {
        transition: '0.5s',
        opacity: isVisible ? 1 : 0,
        transform: `rotate(${directions({ isRtl })?.[$direction] ?? 0}deg)`,
      },
    }),
)

function Arrow({
  color = 'icon.arrowBlue',
  direction = 'down',
  fill = 'transparent',
  strokeWidth = 1.5,
  ...props
}) {
  return (
    <ArrowBox viewBox='0 0 16 12' $direction={direction} {...props}>
      <Path
        d='M15 8L8 0.999999L1 8'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </ArrowBox>
  )
}

Arrow.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
}

export default Arrow
